import { useState, useEffect } from "react";
import { Template } from "@/types";

export interface WizardStep {
  step: number;
  title: string;
  description: string;
  canGoBack: boolean;
}

export const useWizard = () => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [selectedTemplate, setSelectedTemplate] = useState<Template | null>(null);
  const [currentStep, setCurrentStep] = useState(1);

  // Параметры встречи относятся к выбранной загрузке, поэтому живут здесь:
  // сбрасываются тем же selectFile, что меняет файл, — забыть сброс нельзя.
  const [speakerNames, setSpeakerNames] = useState("");
  const [meetingContext, setMeetingContext] = useState("");
  const [meetingParamsOpen, setMeetingParamsOpen] = useState(false);

  /**
   * Единственная точка смены выбора: новый файл (или null — «начать заново»)
   * сбрасывает шаблон и параметры встречи и сворачивает их блок.
   */
  const selectFile = (file: File | null) => {
    setSelectedFile(file);
    setSelectedTemplate(null);
    setSpeakerNames("");
    setMeetingContext("");
    setMeetingParamsOpen(false);
  };

  // Определяем текущий шаг на основе состояния
  useEffect(() => {
    if (!selectedFile) {
      setCurrentStep(1);
    } else if (!selectedTemplate) {
      setCurrentStep(2);
    } else {
      setCurrentStep(3);
    }
  }, [selectedFile, selectedTemplate]);

  const steps: WizardStep[] = [
    {
      step: 1,
      title: "Выберите файл",
      description: "Загрузите аудио или видео файл",
      canGoBack: false,
    },
    {
      step: 2,
      title: "Выберите шаблон",
      description: "Выберите шаблон обработки",
      canGoBack: true,
    },
    {
      step: 3,
      title: "Обработка",
      description: "Загрузка и обработка файла",
      canGoBack: true,
    },
  ];

  const goToPreviousStep = () => {
    if (currentStep === 3) {
      setSelectedTemplate(null);
    } else if (currentStep === 2) {
      selectFile(null);
    }
  };

  const resetWizard = () => {
    selectFile(null);
    setCurrentStep(1);
  };

  const getCurrentStep = () => steps.find((s) => s.step === currentStep);

  const canGoBack = getCurrentStep()?.canGoBack ?? false;

  return {
    selectedFile,
    selectFile,
    selectedTemplate,
    setSelectedTemplate,
    currentStep,
    steps,
    goToPreviousStep,
    resetWizard,
    canGoBack,
    getCurrentStep,
    speakerNames,
    setSpeakerNames,
    meetingContext,
    setMeetingContext,
    meetingParamsOpen,
    setMeetingParamsOpen,
  };
};
